import { portsEvent, profileTypeEnum, getProfileTypeEnum } from "@components/templates/Profile/ProfileHeader/profile-enum";
import { companyEvents } from "@containers/CompanyProfile/utils/enum.js";
import { redirectingProfileEnum, redirectionTypePayload } from "@core/global/global-country-dictionary";
import { generateTrackingObject } from "@core/global/global-country-functions";
import { trademoTrackingEvents } from "@core/global/trademo-tracking";
import { generateQueryString } from "@core/utility/utility";
import { getEventName, getUserActivePlan } from "@helpers/profileHelper";
import { setRedirectionIdsArrayHandler } from "@redux/User/userDetailsSlice";
import { getApiUrl } from "@utils/baseUrl";
import { CLOUDINARY_INTEL_BASE_URL, boltIconTooltipText } from "@utils/enum";
import { getIntelUrl } from "@utils/intelUrl";
import axios from "axios";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import ReactTooltip from "react-tooltip";
const profileApiEndPoint = {
  getProfileSlug: getApiUrl("getProfileSlugID"),
};

const RedirectProfile = ({ profileType, profileId, profileName, dataSource = "US-IMPORTS", showLogo = false, redirectEvent = false, countryName = "US", countryType = "import", tooltipField = "", fromDashboard, isCompany, fromShipments = false, isTrendsTab, showTwoLevel, isSalesForce }) => {
  const [logisticsAccess, setLogisticsAccess] = useState(false);
  const {
    creditDetails: { planAccess },
  } = useSelector((state) => state.userDetails);
  const dispatch = useDispatch();
  const redirectionIdsArr = useSelector((state) => state?.userDetails?.redirectionIdsArr ?? []);
  const { pathname } = useLocation();

  useEffect(() => {
    const isLogisticProfile = redirectingProfileEnum[profileType]?.redirectionType && planAccess?.is_logistic_profile;
    setLogisticsAccess(isLogisticProfile);
  }, [planAccess, profileType]);

  const handleRedircetion = (index) => {
    if (isSalesForce) return;
    const companyId = Array.isArray(profileId) && index !== undefined && profileId[index] ? profileId[index] : profileId;
    dispatch(setRedirectionIdsArrayHandler(companyId));
    let params = {
      profile_type: redirectingProfileEnum[profileType]?.payloadType,
      _id: Array.isArray(profileId) && index !== undefined && profileId[index] ? profileId[index] : profileId,
    };
    if (fromDashboard) {
      params.from = "dashboard";
    }
    axios
      .post(profileApiEndPoint.getProfileSlug, params)
      .then((response) => {
        const queryParams = {
          country: dataSource === "GLOBAL-IMPORTS" ? "global data" : countryName ? (countryName.toUpperCase() === "US" ? countryName.toUpperCase() : countryName.toLowerCase() === "united kingdom" ? "uk" : countryName.toLowerCase()) : "colombia",
          type: countryType ? countryType.toLowerCase() : "export",
          profileName: profileType,
          dataSource: dataSource,
        };
        const queryString = generateQueryString(queryParams);
        let url = `${getIntelUrl()}${redirectingProfileEnum[profileType]?.redirectionType}/${response?.data?.data?.slug}/${response?.data?.data?.redirection_id}` + "?" + queryString;
        window.open(url, "_blank");
      })
      .catch(() => {
        toast.error("No profile found in our system !!!");
      });
    if (isCompany) {
      return trademoTrackingEvents(getEventName(profileTypeEnum.company, companyEvents[redirectionTypePayload[profileType]]?.profileClick), generateTrackingObject(dataSource, pathname, getUserActivePlan()));
    }
    if (redirectEvent) {
      trademoTrackingEvents(getEventName(profileTypeEnum.ports, portsEvent[redirectionTypePayload[profileType]]?.profileClick), generateTrackingObject(dataSource, pathname, getUserActivePlan()));
    }
    if (fromShipments) {
      let eventName = redirectingProfileEnum[profileType]?.payloadType + "_profile_redirection_from_autosuggest";
      trademoTrackingEvents(eventName, generateTrackingObject(dataSource, pathname, getUserActivePlan()));
    }
  };

  const handleBoltIconClick = () => {
    const redirectionUrl = redirectingProfileEnum[profileType]?.redirectionType;
    window.open(`/sample-${redirectionUrl}`);
  };

  const textTransform = profileType === getProfileTypeEnum.tradeLane ? "text-uppercase" : "text-capitalize";
  return profileId && profileType && redirectingProfileEnum[profileType] && logisticsAccess ? (
    Array.isArray(profileName) ? (
      profileName.map((profile, index) => (
        <a className={`btn-link trademo-link py-0 ${textTransform} ${redirectionIdsArr.includes(Array.isArray(profileId) && index !== undefined && profileId[index] ? profileId[index] : profileId) ? "text_visited" : ""} ${isSalesForce ? "!tw-cursor-not-allowed" : ""}`} onClick={() => handleRedircetion(index)}>
          {(profile && profile.toLowerCase()) || "NA"}
          {index < profileName.length - 1 ? "," : ""}
        </a>
      ))
    ) : fromShipments ? (
      <span className="view_profile_search_container" onClick={() => handleRedircetion()}>
        {profileType === "vocc" || profileType === "nvocc" || profileType === "freightForwarder" ? (
          <>
            Discover more insights about <span className="profile_details cursor-pointer text-capitalize">{profileName ? profileName.split(" - ")[0].trim() : "NA"}</span>
          </>
        ) : (
          <>
            Discover more insights about <span className="profile_details cursor-pointer text-capitalize">{profileName ? profileName.toLowerCase() : "NA"}</span>
          </>
        )}
      </span>
    ) : (
      <>
        <a
          className={`btn-link cursor-pointer ${fromDashboard ? "trademo-link-dashboard" : "trademo-link"}  py-0 ${textTransform} ${redirectionIdsArr.includes(Array.isArray(profileId) && profileId[0] ? profileId[0] : profileId) ? "text_visited" : ""} ${isSalesForce ? "!tw-cursor-not-allowed" : ""}`}
          onClick={
            isSalesForce
              ? () => {
                  return;
                }
              : () => handleRedircetion()
          }
          data-for="redirection-text"
          data-tip={tooltipField}>
          {profileName ? (!showTwoLevel && isTrendsTab && profileName.length >= 30 ? profileName.slice(0, 30) + "..." : profileName) : "NA"}
          {fromDashboard ? (
            <svg xmlns="http://www.w3.org/2000/svg" height="14" fill="#7143f1" viewBox="0 -960 960 960" width="14">
              <path d="M185.087-105.869q-32.507 0-55.862-23.356-23.356-23.355-23.356-55.862v-589.826q0-32.74 23.356-56.262 23.355-23.521 55.862-23.521H459v79.783H185.087v589.826h589.826V-459h79.783v273.913q0 32.507-23.521 55.862-23.522 23.356-56.262 23.356H185.087ZM395.001-339 340-395.001l379.912-379.912H519v-79.783h335.696V-519h-79.783v-199.912L395.001-339Z" />
            </svg>
          ) : (
            <></>
          )}
        </a>
        <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="bottom" id="redirection-text" />
      </>
    )
  ) : fromShipments ? (
    <></>
  ) : (
    <>
      <span className={textTransform}>{(profileName && Array.isArray(profileName) ? profileName.join(", ") : profileName && profileName.toLowerCase()) || "NA"}</span>
      {showLogo && profileName && !logisticsAccess ? (
        <>
          <a target="_blank" className="cursor-pointer" onClick={() => handleBoltIconClick(profileType)} id="bolt-icon" data-tip={boltIconTooltipText}>
            <img src={`${CLOUDINARY_INTEL_BASE_URL}/v1684478309/intel/icons/Lightning-alt_t9mkjb.svg`} height={"18px"} width={"18px"} />
          </a>
          <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="bottom" id="bolt-icon" />
        </>
      ) : null}
    </>
  );
};
export default RedirectProfile;
